import { takeLatest, select, call, put } from 'redux-saga/effects';

import isEmpty from 'lodash/isEmpty';
import {
  PAPERWORK_COMMON_ACTION_TYPES,
  paperworkCommonActions,
} from '../actions/common';

import {
  getAppointmentId,
  getPaperworkFormSteps,
  getAllPaperworkSteps,
} from '../../../utils/paperwork';
import { selectShowPaperworkAppointmentQuestionStep } from '../selectors/paperwork-additional-info';
import { selectAppRequestEmergencyContactInfo } from '../../data/selectors';
import {
  selectPaperworkAppointmentIsAllConsentsSigned,
  selectPaperworkAppointmentQuestionAnswers,
  selectPaperworkAppointmentTenantSkipInsurance,
} from '../selectors/paperwork-get-appointment-details';
import { consts } from '../requests/paperwork-get-additional-info';

function* determineRoutes() {
  const uuid = yield call(getAppointmentId);

  const requestContactInfo = yield select(selectAppRequestEmergencyContactInfo);

  const isConsentsSigned = yield select(
    selectPaperworkAppointmentIsAllConsentsSigned,
  );

  const showPaperworkAppointmentQuestionStep = yield select(
    selectShowPaperworkAppointmentQuestionStep,
  );

  const paperworkAppointmentQuestionAnswers = yield select(
    selectPaperworkAppointmentQuestionAnswers,
  );

  const includesAdditionalInfoQuestions =
    !isEmpty(paperworkAppointmentQuestionAnswers) ||
    Boolean(showPaperworkAppointmentQuestionStep);

  const skipInsurance = yield select(
    selectPaperworkAppointmentTenantSkipInsurance,
  );

  const payload = {
    id: uuid,
    requestContactInfo,
    isConsentsSigned,
    includesAdditionalInfoQuestions,
    skipInsurance,
  };

  const formSteps = yield call(getPaperworkFormSteps, payload);

  const allPages = yield call(getAllPaperworkSteps, payload);

  yield put(
    paperworkCommonActions.setPaperworkPageInfo({ allPages, formSteps }),
  );
}

export function* determinePaperworkFlowRoutes() {
  yield takeLatest(
    PAPERWORK_COMMON_ACTION_TYPES.DETERMINE_PAPERWORK_FLOW_ROUTES,
    determineRoutes,
  );
  yield takeLatest(consts.SUCCEED, determineRoutes);
}



// WEBPACK FOOTER //
// ./src/redux/paperwork/sagas/determine-paperwork-flow-routes.js